<script>
  import { get } from "svelte/store";
  import { onDestroy } from "svelte";

  import {
    am_selected_adaptations,
    am_sideBySideComparisonStore,
  } from "./stores_adaptation_measures.js";

  // Incoming variables
  export let viewAdaptationOption;

  // Hold state if single-select, this has to come from the outside so other radio buttons
  // know what group they are in.
  export let radioSelected;

  //
  // Initialization code
  //
  const old = get(am_selected_adaptations);
  old[viewAdaptationOption.toggleValue] = false;
  am_selected_adaptations.set(old);

  //
  // Lifecycle methods
  //
  onDestroy(async () => {
    radioSelected = false;
  });

  //
  // Reactive functions
  //

  // In single-select mode, when a user selects a radio button, reset the selected adaptations to be solely the one
  // the user clicked.
  $: {
    // Only react to state changes for THIS option
    if (radioSelected === viewAdaptationOption.toggleValue) {
      const old = get(am_selected_adaptations);
      let newSelected = [old.length];
      for (let i = 0; i < old.length; i++) {
        newSelected[i] = i == viewAdaptationOption.toggleValue;
      }

      am_selected_adaptations.set(newSelected);
    }
  }

  // Supporting functions
  const slugify = (str = "") =>
    str.toLowerCase().replace(/ /g, "-").replace(/\./g, "");
</script>

<span >
  <span class="rowzz">
    <span class="pr-5">
    <input
      class="sr-only"
      type="radio"
      id={slugify(viewAdaptationOption.buttonName)}
      bind:group={radioSelected}
      value={viewAdaptationOption.toggleValue}
    />
  </span>
  <span class="colzz">
    <label class="view-button" for={slugify(viewAdaptationOption.buttonName)}>
      {viewAdaptationOption.buttonName} 
       <!-- <span class="info-bubble" title={viewAdaptationOption.subtitle}> &#9432;</span> -->
    </label>
  </span>
  </span>

  <!-- radio subtitle popup  -->
  <div
    class="radio-subtitle-popups"
    id="adaptation-measures-widget-container" 
    for={slugify(viewAdaptationOption.buttonName)}
  >
    <calcite-popover class="subtitle-popup" heading={viewAdaptationOption.buttonName} reference-element={viewAdaptationOption.buttonName} closable>
      <div style="margin: 0px" class="radio-subtitle-text-container">
        <div class="adaptation-choice-subtitle">{viewAdaptationOption.subtitle}</div>
      </div>
    </calcite-popover>
    <div class="radio-info-icon-container">
      <calcite-icon class="radio-info-icon" id={viewAdaptationOption.buttonName} icon="information"></calcite-icon>
    </div>
  </div>

  <div class="adaptation-choice-subtitle subtitle-big-screen">{viewAdaptationOption.subtitle}</div>
  
</span>

<style>
 .view-button {
  font-size: medium;
 }

 /* .info-bubble {
  font-size: small;
  vertical-align: super;
 } */
</style>
